import { Component, OnInit } from '@angular/core';
import { DocumentReader, TextFieldFormat } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-text-cell',
    templateUrl: './text-cell.component.html',
    styleUrls: ['./text-cell.component.scss'],
    standalone: false
})
export class TextCellComponent implements OnInit {
  TextFieldFormat = TextFieldFormat;
  value: any;
  format: string;

  constructor() {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    this.format = field?.settings?.format;
    if (!this.format) {
      this.format = TextFieldFormat.SingleLine;
    }

    const data = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    this.value = data;
  }
}
